
import { SyntheticEvent } from 'react';
import { Featured } from 'src/types';
import { formatLink } from 'src/utils/featuredPosts';
import i18n from 'src/utils/translate';

type Props = {
  featuredPost: Featured;
  onClick: (e: SyntheticEvent) => void;
  onDismiss: () => void;
}

export default function NormalFeaturedPost({featuredPost, onClick, onDismiss}: Props) {
  const formattedLink = formatLink(featuredPost.callToActionUrl);

  return (
    <div className="results-post">
      {featuredPost.imageUrl &&
        <a
          href={formattedLink}
          rel="nofollow ugc"
          target="_blank"
          onClick={onClick}
        >
          <img alt={featuredPost.title} className="featured-post__image" src={featuredPost.imageUrl} />
        </a>
      }
      <h3 className="results-post__title">
        <span className="results-post__title__content-dismiss">
          <button
            aria-label="close"
            className="icon icon-close"
            title="close"
            onClick={onDismiss}
          />
        </span>
        <a
          href={formattedLink}
          rel="nofollow ugc"
          target="_blank"
          onClick={onClick}
        >
          {featuredPost.title}
        </a>
      </h3>
      <div className="results-post__body">
        {featuredPost.snippet}
      </div>
      <div>
        <a
          className="btn btn-secondary"
          href={formattedLink}
          rel="nofollow ugc"
          target="_blank"
          onClick={onClick}
        >
          <span className="featured-post__call-to-action">
            {featuredPost.callToActionText}
          </span>
        </a>
      </div>
      <div className="featured-post__footer">
        <div className="featured-post__footer--content">
          {i18n.t('Featured by')} {featuredPost.featuredByCommunityName}
        </div>
      </div>
    </div>
  );
}
